import React from "react"; //usar codigo JSX
import { Helmet } from "react-helmet";
import MainBanner from "../components/Web/MainBanner";
import HomeCourses from "../components/Web/HomeCourses";
import HowMyCoursesWork from "../components/Web/HowMyCoursesWork";
import ReviewCourses from "../components/Web/ReviewCourses";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Israel garcia Home</title>
        <meta
          name="description"
          content="Home||Web sobre programación "
          data-react-helmet="true"
        />
      </Helmet>
      {/*FRAGMENT */}
      <MainBanner />
      <HomeCourses />
      <HowMyCoursesWork />
      <ReviewCourses />
    </>
  );
}
